import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getCardDetail = async (params: object) => {
  return await GET({ url: Api.getCardDetail, params, showError: false })
}
